/* eslint-disable react/no-multi-comp */
import React from "react"
import { useInView } from "react-intersection-observer"
import Img from "gatsby-image/withIEPolyfill"
import { css, formatDate, formatSlug } from "@jsUtils"
import { Analytics } from "@shared"
import styles from "@pageStyles/resources.module.scss"

const TrackedLink = Analytics("a")

const ResourcesArticle = ({ article, featured }) => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  })

  // build list of categories to display
  let categoryList = [article.category]

  if (article.tags) {
    categoryList.push(...article.tags)
  }

  categoryList = categoryList
    .filter((category, index) => categoryList.indexOf(category) === index)
    .join(", ")

  return (
    <TrackedLink
      adata="RESOURCES.READMORE"
      ascope="CTAS"
      className={css(styles.article, featured && styles.articleFeatured, inView && styles.inView)}
      href={`/${formatSlug(article.category)}/${article.slug}`}
      ref={ref}
    >
      <div className={styles.articleTop}>
        {article.thumbnail?.fluid && (
          <Img
            alt={article.thumbnail?.title}
            className={styles.articleImage}
            fluid={article.thumbnail?.fluid}
          />
        )}
      </div>

      <div className={styles.articleBottom}>
        <p className={styles.articleCategory}>{categoryList}</p>
        <p className={styles.articleTitle}>{article.title}</p>

        <div className={styles.articleBar}>
          <p className={styles.articleDate}>{formatDate(article.date)}</p>
          {featured && <p className={styles.articleLabel}>Featured</p>}
        </div>
      </div>
    </TrackedLink>
  )
}

export default ResourcesArticle
